import { render, staticRenderFns } from "./SaleItemsTable.vue?vue&type=template&id=41ae8be9&scoped=true&"
import script from "./SaleItemsTable.vue?vue&type=script&lang=js&"
export * from "./SaleItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./SaleItemsTable.vue?vue&type=style&index=0&id=41ae8be9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ae8be9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ae8be9')) {
      api.createRecord('41ae8be9', component.options)
    } else {
      api.reload('41ae8be9', component.options)
    }
    module.hot.accept("./SaleItemsTable.vue?vue&type=template&id=41ae8be9&scoped=true&", function () {
      api.rerender('41ae8be9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-bar/components/SaleItemsTable.vue"
export default component.exports